/** @file Sets a bone's length (px, >= 0); generated socket bones are refused (the socket owns it). */
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCommand } from '../defineCommand';
import { defineSetter } from '../_shared/defineSetter';
import { assertNotSocketBone } from '../_shared/assertNotSocketBone';

const lengthSetter = defineSetter({
  domain: 'bone',
  kind: 'bone',
  field: 'length',
  schema: prim.finite.nonnegative(),
  description: 'Set a bone length in px (>= 0; drawn in the editor and used by IK stretch); generated socket bones are refused (their length is the socket axis).',
});

/** bone.setLength: the socket-bone guard runs before the setter writes; the current length is a no-op (R2-13). */
export const command = defineCommand({
  ...lengthSetter,
  apply(draft, input, ctx) {
    const bone = ctx.resolve('bone', input.target);
    assertNotSocketBone(draft, bone);
    if (draft.bones[bone]?.length === input.value) return;
    lengthSetter.apply(draft, input, ctx);
  },
});
